import React from 'react';
import {
  Box,
  Button,
  Card,
  Checkbox,
  colors,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { GoogleSpreadsheet } from 'google-spreadsheet';
import _ from 'lodash';
import FormDialog from '../../components/FormDialog';
import toast from 'react-hot-toast';
import FABAction from '../../components/FABAction';
import GeneralLoader from '../../components/GeneralLoader';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import Add from '@mui/icons-material/Add';
import DeleteForever from '@mui/icons-material/DeleteForever';
import DialogConfirmation from '../../components/DialogConfirmation';
import QuestionDialog from '../../components/QuestionDialog';
import IconButton from '@mui/material/IconButton';
import FormlistDialog from '../../components/FormlistDialog';
import { useLocation, useNavigate } from 'react-router-dom';
import { exportData } from '../../helpers/exporter';
import Cookies from 'universal-cookie';
import { fetchWith401Check } from '../../helpers/http';
import SectionDialog from '../../components/SectionDialog';

// Default styles
const pageWidth = { width: '100%', backgroundColor: 'white', padding: 2, marginTop: 1, marginBottom: 1 };
const pageWidthHeader = {
  width: '100%',
  backgroundColor: 'white',
  padding: 2,
  marginTop: 1,
  marginBottom: 1,
};

const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

// Config variables
const SPREADSHEET_ID = process.env.REACT_APP_SPREADSHEET_ID;
const CLIENT_EMAIL = process.env.REACT_APP_CLIENT_EMAIL;
const PRIVATE_KEY = process.env.REACT_APP_PRIVATE_KEY.replace(/\n/g, '\n');
const SHEET_PROPS_ID = 1347492723;
const doc = new GoogleSpreadsheet(SPREADSHEET_ID);

const inputProps = {
  step: 300,
};

const Creator = ({ userInfo }) => {
  const cookies = new Cookies();
  const navigate = useNavigate();
  const location = useLocation();
  const [authGranted, setAuthGranted] = React.useState(false);
  // const [sheet, setSheet] = React.useState({});
  // const [rows, setRows] = React.useState({});
  const [headers, setHeaders] = React.useState([]);
  const [description, setDescription] = React.useState('');
  const [tableProps, setTableProps] = React.useState([]);
  const [openFormDialog, setFormDialogOpen] = React.useState(false);
  const [openQuestionDialog, setQuestionDialogOpen] = React.useState(false);
  const [openSectionDialog, setSectionDialogOpen] = React.useState(false);
  const [openFormlistDialog, setOpenFormlistDialog] = React.useState(false);
  const [itemMeta, setItemMeta] = React.useState({});
  const [questionMeta, setQuestionMeta] = React.useState({});
  const [confirmationOpen, setConfirmationOpen] = React.useState(false);
  const [objectLibraries, setObjectLibraries] = React.useState([]);
  const [fieldErrors, setFieldErrors] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const getProps = async () => {
    try {
      await doc.loadInfo();
      const sheetData = await doc.sheetsById[SHEET_PROPS_ID];
      await sheetData.loadCells(); // Prevent This cell has not been loaded yet
      const B2 = await sheetData.getCellByA1('B2');
      setTableProps(JSON.parse(B2.value));

      console.log('check table props', B2.value);
      setHeaders(JSON.parse(B2.value).data?.attributes?.headers);
      setDescription(JSON.parse(B2.value).data?.attributes?.description);
    } catch (error) {
      alert(error.message);
    }
  };

  const fetchProps = async () => {
    setIsLoading(true);
    fetchWith401Check(`${API_URL}/tableprops?type=table_headers`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        setIsLoading(false);
        return Promise.reject(response);
      })
      .then(function (response) {
        const headerData = response.data;
        setTableProps(headerData);
        setHeaders(headerData.data?.attributes?.headers);
        setDescription(headerData.data?.attributes?.description);
        setIsLoading(false);
      })
      .catch(function (err) {
        setIsLoading(false);
        return toast.error(err.message);
      });
  };

  const fetchObjectLibraries = async () => {
    fetchWith401Check(`${API_URL}/tableprops?type=object_libraries`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const objectLibrariesData = response?.data?.data;
        setObjectLibraries(objectLibrariesData);
      })
      .catch(function (err) {
        return toast.error(err.message);
      });
  };

  const initAuth = async () => {
    try {
      // Initialize Auth - see https://theoephraim.github.io/node-google-spreadsheet/#/getting-started/authentication
      await doc.useServiceAccountAuth({
        // env var values are copied from service account credentials generated by google
        // see "Authentication" section in docs for more info
        client_email: CLIENT_EMAIL,
        private_key: PRIVATE_KEY,
      });

      // const sheetData = await doc.sheetsByIndex[0];
      // const rowsData = await sheetData.getRows();
      // await sheetData.loadHeaderRow();

      // setHeaders(sheetData.headerValues);
      // setSheet(sheetData);
      // setRows(rowsData);
      setAuthGranted(true);
    } catch (error) {
      alert(error.message);
      setAuthGranted(false);
    }
  };

  // const appendSpreadsheet = async (row) => {
  //   try {
  //     await doc.useServiceAccountAuth({
  //       client_email: CLIENT_EMAIL,
  //       private_key: PRIVATE_KEY,
  //     });
  //     // loads document properties and worksheets
  //     await doc.loadInfo();

  //     const sheet = doc.sheetsById[SHEET_ID];
  //     const result = await sheet.addRow(row);
  //   } catch (e) {
  //     console.error('Error: ', e);
  //   }
  // };

  // const createNewRow = () => {
  //   const newRow = { Name: 'new name', Value: 'new value lololo' };

  //   appendSpreadsheet(newRow);
  // };

  const updateHeaders = async (index, value, type) => {
    try {
      let _header = headers;
      _header[index] = { ..._header[index], [type]: value };
      setHeaders([..._header]);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const addQuestion = (question) => {
    const isDuplicated = headers.filter((item) => item.tag === question.tag);
    if (isDuplicated.length > 0) return false;
    headers.push(question);
    return true;
  };

  const addSection = (section) => {
    headers.push({ ...section, type: 'section' });
    return true;
  };

  const updateSpreadSheetHeaders = async () => {
    try {
      const arrayToSend = ['id'];
      for (const [key, value] of Object.entries(headers)) {
        arrayToSend.push(value.tag);
      }

      await doc.useServiceAccountAuth({
        client_email: CLIENT_EMAIL,
        private_key: PRIVATE_KEY,
      });

      await doc.loadInfo();
      const sheet = doc.sheetsById[SHEET_PROPS_ID];
      // sheet.setHeaderRow(['name', 'age', 'phone']);
      const result = await sheet.setHeaderRow(arrayToSend);
      toast.success('Data saved successfully');
      setIsLoading(false);
    } catch (e) {
      console.error('Error: ', e);
      setIsLoading(false);
    }
  };

  const updateTableProps = async () => {
    try {
      // await doc.useServiceAccountAuth({
      //   client_email: CLIENT_EMAIL,
      //   private_key: PRIVATE_KEY,
      // });
      // // loads document properties and worksheets
      // await doc.loadInfo();

      if (!description) {
        toast.error('Please update your description');
        return false;
      }

      const _fieldErrors = {};

      headers.forEach((item) => {
        if (item.isRequired && !(item.tag && item.label)) {
          console.log('check tag', item.tag);
          _fieldErrors[item.tag] = true;
        }
      });

      if (!_.isEmpty(_fieldErrors)) {
        console.log(_fieldErrors);
        return toast.error('Please fill all required fields');
      }

      const _table = tableProps;
      _table.data.attributes.headers = headers;
      _table.data.attributes.description = description;

      // const sheetData = doc.sheetsById[SHEET_PROPS_ID];
      // await sheetData.loadCells(); // Prevent This cell has not been loaded yet

      // const cellB2 = await sheetData.getCellByA1('B2');
      // cellB2.value = JSON.stringify(_table);

      // await sheetData.saveUpdatedCells();

      setIsLoading(true);

      const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
        body: JSON.stringify({ data: _table, type: 'table_headers' }),
      };

      fetchWith401Check(`${API_URL}/tableprops`, requestOptions)
        .then(function (response) {
          if (response.ok) {
            updateSpreadSheetHeaders();
            return response.json();
          }
          return Promise.reject(response);
        })
        .catch(function (err) {
          setIsLoading(false);
          return alert(JSON.stringify(err));
        });
    } catch (e) {
      toast.error(e.message);
      setIsLoading(false);
    }
  };

  const handleChangeQuestionLocation = (question, question_index, direction) => {
    const _questions = headers;
    const index_target = direction === 'upward' ? -1 : +1;
    [_questions[question_index], _questions[question_index + index_target]] = [_questions[question_index + index_target], _questions[question_index]];

    setHeaders([..._questions]);
  };

  const handleQuestionDelete = (item, index, isConfirmed) => {
    if (!isConfirmed) {
      setQuestionMeta({ ...item, index });
      return setConfirmationOpen(true);
    }

    let _questions = headers;
    _questions.splice(index, 1);
    setHeaders(_questions);
    setConfirmationOpen(false);
  };

  const handleChangeOptionLocation = (question, question_index, option, option_index, direction) => {
    const _options = question.options;
    const index_target = direction === 'upward' ? -1 : +1;
    [_options[option_index], _options[option_index + index_target]] = [_options[option_index + index_target], _options[option_index]];
    updateHeaders(question_index, _options, 'options');
  };

  // React.useEffect(() => {
  //   initAuth();
  // }, []);

  // React.useEffect(() => {
  //   if (authGranted) getProps();
  // }, [authGranted]);

  const updateQuestionCategory = (item, index, category) => {
    const tempValue = item.category || [];
    if (!_.isEmpty(tempValue)) {
      if (tempValue.includes(category)) {
        const _index = _.findIndex(tempValue, (val) => {
          return val.tag === category;
        });
        tempValue.splice(_index, 1);
      } else {
        tempValue.push(category);
      }
    } else {
      tempValue.push(category);
    }

    updateHeaders(index, tempValue, 'category');
  };

  React.useEffect(() => {
    fetchProps();
    fetchObjectLibraries();
  }, []);

  const doLogOut = () => {
    cookies.remove('token', { path: '/' });
    window.location.href = '/';
  };

  return (
    <Box sx={{ backgroundColor: colors.blue[100], padding: 2, minHeight: '100vh' }}>
      <Container maxWidth='md'>
        <Stack direction='row' justifyContent='space-between' p={1}>
          <Typography sx={{ fontWeight: '700' }}>Admin name: {userInfo.name}</Typography>
          <Stack direction='row' spacing={1}>
            <Typography onClick={() => navigate('/portal')} sx={{ fontWeight: 'bold', cursor: 'pointer' }}>
              Portal
            </Typography>
            <Divider flexItem orientation='vertical' />
            <Typography onClick={doLogOut} sx={{ fontWeight: 'bold', cursor: 'pointer', color: colors.red[400] }}>
              Logout
            </Typography>
          </Stack>
        </Stack>

        <Card sx={pageWidthHeader}>
          <Stack direction='column'>
            <Stack my={2}>
              <Typography variant='h3' sx={{ textAlign: 'center', color: colors.grey[900] }}>
                Form Editor
              </Typography>
            </Stack>
            <Stack mb={2}>
              <Typography variant='body2' sx={{ fontStyle: 'italic', textAlign: 'center', color: colors.grey[800] }}>
                Any changes made on this form need to be saved by clicking the save button on your bottom-right screen
              </Typography>
            </Stack>
          </Stack>
        </Card>

        <Stack direction='row' justifyContent='center'>
          <GeneralLoader isLoading={isLoading} />
        </Stack>

        <Card sx={pageWidthHeader}>
          <Stack mb={2} spacing={2}>
            <Typography variant='h6'>Description</Typography>
            <TextField
              required
              variant='outlined'
              label='Form Description'
              placeholder='Insert your form description here'
              value={description}
              onChange={(e) => setDescription(e.currentTarget.value)}
            />
          </Stack>
        </Card>

        <Stack direction='column'>
          <Stack direction='column' sx={{ flexWrap: 'wrap', alignItems: 'center' }}>
            {!_.isEmpty(headers) &&
              headers.map((item, index) => (
                <Card key={index} sx={pageWidth}>
                  {item.type === 'section' && (
                    <Stack direction='column' spacing={1} key={index}>
                      <Stack direction='column' alignItems='flex-end'>
                        <Stack direction='row' p={1} spacing={1}>
                          <Stack direction='row' alignItems='center'>
                            <Checkbox checked={item?.isRequired ? true : false} onChange={(e) => updateHeaders(index, e.target.checked, 'isRequired')} />
                            <Typography>Required</Typography>
                          </Stack>
                          <Stack direction='row' alignItems='center'>
                            <Checkbox checked={item?.isVisible ? true : false} onChange={(e) => updateHeaders(index, e.target.checked, 'isVisible')} />
                            <Typography>Visible</Typography>
                          </Stack>
                          <Stack direction='row' alignItems='center'>
                            <Checkbox checked={item?.isEnabled ? true : false} onChange={(e) => updateHeaders(index, e.target.checked, 'isEnabled')} />
                            <Typography>Enabled</Typography>
                          </Stack>
                          <Divider orientation='vertical' flexItem />
                          <Stack direction='row' p={1}>
                            <IconButton
                              onClick={() => handleChangeQuestionLocation(item, index, 'upward')}
                              disabled={index === 0 ? true : false}
                              aria-label='Upward'
                              color='primary'
                            >
                              <ArrowUpward />
                            </IconButton>
                            <IconButton
                              onClick={() => handleChangeQuestionLocation(item, index, 'downward')}
                              disabled={index === headers?.length - 1 ? true : false}
                              aria-label='Downward'
                              color='primary'
                            >
                              <ArrowDownward />
                            </IconButton>
                            <IconButton color='primary' onClick={() => handleQuestionDelete(item, index, false)} aria-label='Delete'>
                              <DeleteForever sx={{ color: 'red' }} />
                            </IconButton>
                          </Stack>
                        </Stack>
                        <Stack direction='row' alignItems='center' justifyContent='flex-end' mr={4}>
                          <Typography variant='body2'>Category:</Typography>
                          <Stack direction='row' alignItems='center'>
                            <Checkbox checked={item?.category?.includes('gp') ? true : false} onChange={(e) => updateQuestionCategory(item, index, 'gp')} />
                            <Typography variant='body2'>Best Practices</Typography>
                          </Stack>
                          <Stack direction='row' alignItems='center'>
                            <Checkbox checked={item?.category?.includes('doc') ? true : false} onChange={(e) => updateQuestionCategory(item, index, 'doc')} />
                            <Typography variant='body2'>Document Repository</Typography>
                          </Stack>
                          <Stack direction='row' alignItems='center'>
                            <Checkbox checked={item?.category?.includes('his') ? true : false} onChange={(e) => updateQuestionCategory(item, index, 'his')} />
                            <Typography variant='body2'>Human Interest Story</Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                      <TextField label='Section Label' type='text' value={item.label} onChange={(e) => updateHeaders(index, e.currentTarget.value, 'label')} />
                    </Stack>
                  )}
                  {item.type !== 'section' && (
                    <Stack direction='column' spacing={1} key={index}>
                      <Stack direction='row' alignItems='center' justifyContent='space-between'>
                        <Typography sx={{ fontWeight: 'bold' }}>Cell: {String.fromCharCode(65 + index)}1</Typography>
                        <Stack direction='column' alignItems='flex-end'>
                          <Stack direction='row' p={1} spacing={1}>
                            <Stack direction='row' alignItems='center'>
                              <Checkbox checked={item?.isRequired ? true : false} onChange={(e) => updateHeaders(index, e.target.checked, 'isRequired')} />
                              <Typography>Required</Typography>
                            </Stack>
                            <Stack direction='row' alignItems='center'>
                              <Checkbox checked={item?.isVisible ? true : false} onChange={(e) => updateHeaders(index, e.target.checked, 'isVisible')} />
                              <Typography>Visible</Typography>
                            </Stack>
                            <Stack direction='row' alignItems='center'>
                              <Checkbox checked={item?.isEnabled ? true : false} onChange={(e) => updateHeaders(index, e.target.checked, 'isEnabled')} />
                              <Typography>Enabled</Typography>
                            </Stack>
                            <Divider orientation='vertical' flexItem />
                            <Stack direction='row' p={1}>
                              <IconButton
                                onClick={() => handleChangeQuestionLocation(item, index, 'upward')}
                                disabled={index === 0 ? true : false}
                                aria-label='Upward'
                                color='primary'
                              >
                                <ArrowUpward />
                              </IconButton>
                              <IconButton
                                onClick={() => handleChangeQuestionLocation(item, index, 'downward')}
                                disabled={index === headers?.length - 1 ? true : false}
                                aria-label='Downward'
                                color='primary'
                              >
                                <ArrowDownward />
                              </IconButton>
                              <IconButton color='primary' onClick={() => handleQuestionDelete(item, index, false)} aria-label='Delete'>
                                <DeleteForever sx={{ color: 'red' }} />
                              </IconButton>
                            </Stack>
                          </Stack>
                          <Stack direction='row' alignItems='center' justifyContent='flex-end' mr={4}>
                            <Typography variant='body2'>Category:</Typography>
                            <Stack direction='row' alignItems='center'>
                              <Checkbox checked={item?.category?.includes('gp') ? true : false} onChange={(e) => updateQuestionCategory(item, index, 'gp')} />
                              <Typography variant='body2'>Best Practices</Typography>
                            </Stack>
                            <Stack direction='row' alignItems='center'>
                              <Checkbox checked={item?.category?.includes('doc') ? true : false} onChange={(e) => updateQuestionCategory(item, index, 'doc')} />
                              <Typography variant='body2'>Document Repository</Typography>
                            </Stack>
                            <Stack direction='row' alignItems='center'>
                              <Checkbox checked={item?.category?.includes('his') ? true : false} onChange={(e) => updateQuestionCategory(item, index, 'his')} />
                              <Typography variant='body2'>Human Interest Story</Typography>
                            </Stack>
                          </Stack>
                        </Stack>
                      </Stack>
                      <Divider />
                      <Stack spacing={2}>
                        <Stack direction='row' sx={{ alignItems: 'center' }} mt={2}>
                          <Typography sx={{ flex: 1 }}>Label: &nbsp;</Typography>
                          <TextField
                            value={item.label}
                            sx={{ flex: 5 }}
                            label='Label'
                            placeholder='Label'
                            id={item.tag}
                            type='text'
                            inputProps={inputProps}
                            size='small'
                            onChange={(e) => updateHeaders(index, e.currentTarget.value, 'label')}
                          />
                        </Stack>
                        <Stack direction='row' sx={{ alignItems: 'center' }}>
                          <Typography sx={{ flex: 1 }}>Tag: &nbsp;</Typography>
                          <TextField
                            value={item.tag}
                            sx={{ flex: 5 }}
                            label='Tagging'
                            placeholder='Tagging'
                            id={item.tag}
                            type='text'
                            inputProps={inputProps}
                            size='small'
                            onChange={(e) => {
                              if (e.currentTarget.value) {
                                const isDuplicated = headers.filter((item) => item.tag === e.currentTarget.value.replace(/\s+/g, '').toLowerCase());
                                if (isDuplicated.length > 0)
                                  return toast.error(`Tag ${e.currentTarget.value.replace(/\s+/g, '').toLowerCase()} is duplicated, please use another tag.`);
                                updateHeaders(index, e.currentTarget.value.replace(/\s+/g, '').toLowerCase(), 'tag');
                              } else {
                                updateHeaders(index, e.currentTarget.value.replace(/\s+/g, '').toLowerCase(), 'tag');
                              }
                            }}
                          />
                        </Stack>
                        <Stack direction='row' sx={{ alignItems: 'flex-start' }} p={2} spacing={2}>
                          <Stack sx={{ flex: 1 }}>
                            <FormControl>
                              <FormLabel id='type'>Type</FormLabel>
                              <RadioGroup
                                aria-labelledby='question type'
                                value={item.type}
                                name='radio-buttons-group-question-type'
                                onChange={(e) => updateHeaders(index, e.currentTarget.value, 'type')}
                              >
                                <FormControlLabel value='text' control={<Radio />} label='Text' />
                                <FormControlLabel value='multiple-text' control={<Radio />} label='Multiple Text' />
                                <FormControlLabel value='radio' control={<Radio />} label='Radio' />
                                <FormControlLabel value='checkbox' control={<Radio />} label='Checkbox' />
                                <FormControlLabel value='html' control={<Radio />} label='HTML' />
                                <FormControlLabel value='attachment' control={<Radio />} label='Attachments' />
                                <FormControlLabel value='thumbnail' control={<Radio />} label='Photo' />
                                <FormControlLabel value='location' control={<Radio />} label='Location' />
                                <FormControlLabel value='institution_agency' control={<Radio />} label='Institution & Agency' />
                              </RadioGroup>
                            </FormControl>
                          </Stack>

                          {['text'].includes(item.type) && (
                            <>
                              <Divider orientation='vertical' flexItem />
                              <Stack direction='column' spacing={2} sx={{ width: '100%', flex: 3 }}>
                                <Stack direction='column' spacing={2}>
                                  <>
                                    {
                                      <Stack direction='column' spacing={1}>
                                        <FormControl>
                                          <FormLabel id='type'>Validation Type</FormLabel>
                                          <RadioGroup
                                            aria-labelledby='validation type'
                                            value={item.validationType}
                                            name='radio-buttons-group-validation-type'
                                            onChange={(e) => updateHeaders(index, e.currentTarget.value, 'validationType')}
                                          >
                                            <FormControlLabel value='text' control={<Radio />} label='Short Text' />
                                            <FormControlLabel value='longtext' control={<Radio />} label='Long Text' />
                                            <FormControlLabel value='number' control={<Radio />} label='Number' />
                                            <FormControlLabel value='date' control={<Radio />} label='Date' />
                                            <FormControlLabel value='email' control={<Radio />} label='Email' />
                                            <FormControlLabel value='url' control={<Radio />} label='URL' />
                                          </RadioGroup>
                                        </FormControl>
                                      </Stack>
                                    }
                                  </>
                                </Stack>
                              </Stack>
                            </>
                          )}

                          {['attachment'].includes(item.type) && (
                            <>
                              <Divider orientation='vertical' flexItem />
                              <Stack direction='column' spacing={2} sx={{ width: '100%', flex: 3 }}>
                                <Stack direction='row' spacing={1} sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
                                  <Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
                                    <Typography variant='body1'>Options</Typography>
                                    <Button
                                      onClick={() => {
                                        setItemMeta({ ...item, index, isExist: false });
                                        setFormDialogOpen(true);
                                      }}
                                      variant='outlined'
                                    >
                                      Add option
                                    </Button>
                                  </Stack>
                                  <Stack>
                                    <Button
                                      onClick={() => {
                                        setItemMeta({ ...item, index, isExist: false });
                                        setOpenFormlistDialog(true);
                                      }}
                                    >
                                      Load from library?
                                    </Button>
                                  </Stack>
                                </Stack>
                                <Divider />
                                <>
                                  {!_.isEmpty(item.options) ? (
                                    <Stack direction='column' spacing={1}>
                                      {item?.options.length <= 100 ? (
                                        <>
                                          {item?.options?.map((item_options, index_options) => (
                                            <Stack key={index_options} direction='row' spacing={1} alignItems='center'>
                                              {item.options_type !== 'object_libraries' ? (
                                                <>
                                                  <Stack direction='row' alignItems='center'>
                                                    <Stack direction='row' p={1}>
                                                      <IconButton
                                                        onClick={() => handleChangeOptionLocation(item, index, item_options, index_options, 'upward')}
                                                        disabled={index_options === 0 ? true : false}
                                                        aria-label='Upward'
                                                        color='primary'
                                                      >
                                                        <ArrowUpward />
                                                      </IconButton>
                                                      <IconButton
                                                        color='primary'
                                                        onClick={() => handleChangeOptionLocation(item, index, item_options, index_options, 'downward')}
                                                        disabled={index_options === item?.options?.length - 1 ? true : false}
                                                        aria-label='Downward'
                                                      >
                                                        <ArrowDownward />
                                                      </IconButton>
                                                    </Stack>
                                                    <Typography variant='body1'>({index_options + 1})</Typography>
                                                    <Button
                                                      onClick={() => {
                                                        setItemMeta({ ...item, index, isExist: true, index_options, item_options, action_type: 'edit' });
                                                        setFormDialogOpen(true);
                                                      }}
                                                      size='small'
                                                      margin='dense'
                                                      color='primary'
                                                    >
                                                      Edit
                                                    </Button>
                                                    <Divider orientation='vertical' flexItem />
                                                  </Stack>

                                                  <Stack direction='column'>
                                                    <Typography variant='body1' sx={{ fontWeight: 700 }}>
                                                      {item_options.value || item_options.label}
                                                    </Typography>
                                                    <Typography variant='body2'>key: {item_options.key}</Typography>
                                                  </Stack>
                                                </>
                                              ) : (
                                                <Box>
                                                  <Stack direction='column'>
                                                    <Typography variant='body1' sx={{ fontWeight: 700 }}>
                                                      {item_options.value || item_options.label}
                                                    </Typography>
                                                    <Typography variant='body2'>key: {item_options.key}</Typography>
                                                  </Stack>
                                                </Box>
                                              )}
                                            </Stack>
                                          ))}
                                        </>
                                      ) : (
                                        <Stack direction='column' spacing={1}>
                                          <Typography variant='body2'>
                                            The data length exceeding the maximum length of 100 rows that can be rendered (The total data length is: &nbsp;
                                            {item.options.length}
                                            ). You can download the data instead by click the download button below then report to your administrator if there
                                            are any changes need to make.
                                          </Typography>
                                          <Button onClick={() => exportData(item.options)}>Download</Button>
                                        </Stack>
                                      )}

                                      <Box>
                                        {item.options_type === 'object_libraries' && (
                                          <Stack direction='column' justifyContent='flex-start'>
                                            <Typography variant='body2' sx={{ fontStyle: 'italic' }}>
                                              notes: item loaded from library only can be edited using library editor.
                                            </Typography>
                                            <Box>
                                              <Button onClick={() => window.open(`/portal/creator/library-editor`, '_blank')}>Library editor?</Button>
                                            </Box>
                                          </Stack>
                                        )}
                                      </Box>
                                    </Stack>
                                  ) : (
                                    <Typography variant='caption'>Please add new option</Typography>
                                  )}
                                </>
                              </Stack>
                            </>
                          )}

                          {['radio', 'checkbox'].includes(item.type) && (
                            <>
                              <Divider orientation='vertical' flexItem />
                              <Stack direction='column' spacing={2} sx={{ width: '100%', flex: 3 }}>
                                <Stack direction='row' spacing={1} sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
                                  <Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
                                    <Typography variant='body1'>Options</Typography>
                                    <Button
                                      onClick={() => {
                                        setItemMeta({ ...item, index, isExist: false });
                                        setFormDialogOpen(true);
                                      }}
                                      variant='outlined'
                                    >
                                      Add option
                                    </Button>
                                  </Stack>
                                  <Stack>
                                    <Button
                                      onClick={() => {
                                        setItemMeta({ ...item, index, isExist: false });
                                        setOpenFormlistDialog(true);
                                      }}
                                    >
                                      Load from library?
                                    </Button>
                                  </Stack>
                                </Stack>
                                <Divider />
                                <>
                                  {!_.isEmpty(item.options) ? (
                                    <Stack direction='column' spacing={1}>
                                      {item?.options.length <= 100 ? (
                                        <>
                                          {item?.options?.map((item_options, index_options) => (
                                            <Stack key={index_options} direction='row' spacing={1} alignItems='center'>
                                              {item.options_type !== 'object_libraries' ? (
                                                <>
                                                  <Stack direction='row' alignItems='center'>
                                                    <Stack direction='row' p={1}>
                                                      <IconButton
                                                        onClick={() => handleChangeOptionLocation(item, index, item_options, index_options, 'upward')}
                                                        disabled={index_options === 0 ? true : false}
                                                        aria-label='Upward'
                                                        color='primary'
                                                      >
                                                        <ArrowUpward />
                                                      </IconButton>
                                                      <IconButton
                                                        color='primary'
                                                        onClick={() => handleChangeOptionLocation(item, index, item_options, index_options, 'downward')}
                                                        disabled={index_options === item?.options?.length - 1 ? true : false}
                                                        aria-label='Downward'
                                                      >
                                                        <ArrowDownward />
                                                      </IconButton>
                                                    </Stack>
                                                    <Typography variant='body1'>({index_options + 1})</Typography>
                                                    <Button
                                                      onClick={() => {
                                                        setItemMeta({ ...item, index, isExist: true, index_options, item_options, action_type: 'edit' });
                                                        setFormDialogOpen(true);
                                                      }}
                                                      size='small'
                                                      margin='dense'
                                                      color='primary'
                                                    >
                                                      Edit
                                                    </Button>
                                                    <Divider orientation='vertical' flexItem />
                                                  </Stack>

                                                  <Stack direction='column'>
                                                    <Stack direction='row' alignItems='center' spacing={1}>
                                                      <Stack direction='column'>
                                                        <Typography variant='body1' sx={{ fontWeight: 700 }}>
                                                          {item_options.value || item_options.label}
                                                        </Typography>
                                                        <Typography variant='body2'>key: {item_options.key}</Typography>
                                                      </Stack>
                                                      {/* {index_options + 1 === item.options.length && (
                                                      <Stack direction='row' alignItems='center'>
                                                        <Checkbox
                                                          checked={item?.isRequired ? true : false}
                                                          onChange={(e) => updateHeaders(index, e.target.checked, 'isRequired')}
                                                        />
                                                        <Typography>Is other?</Typography>
                                                      </Stack>
                                                    )} */}
                                                    </Stack>
                                                  </Stack>
                                                </>
                                              ) : (
                                                <Box>
                                                  <Stack direction='column'>
                                                    <Stack direction='row' alignItems='center' spacing={1}>
                                                      <Typography variant='body1' sx={{ fontWeight: 700 }}>
                                                        {item_options.value || item_options.label}
                                                      </Typography>
                                                      {/* <Typography variant='body2'>key: {item_options.key}</Typography>
                                                    {index_options + 1 === item.options.length && (
                                                      <Stack direction='row' alignItems='center'>
                                                        <Checkbox
                                                          checked={item?.isRequired ? true : false}
                                                          onChange={(e) => updateHeaders(index, e.target.checked, 'isRequired')}
                                                        />
                                                        <Typography>Is other?</Typography>
                                                      </Stack>
                                                    )} */}
                                                    </Stack>
                                                  </Stack>
                                                </Box>
                                              )}
                                            </Stack>
                                          ))}
                                        </>
                                      ) : (
                                        <Stack direction='column' spacing={1}>
                                          <Typography variant='body2'>
                                            The data length exceeding the maximum length of 100 rows that can be rendered (The total data length is: &nbsp;
                                            {item.options.length}
                                            ). You can download the data instead by click the download button below then report to your administrator if there
                                            are any changes need to make.
                                          </Typography>
                                          <Button onClick={() => exportData(item.options)}>Download</Button>
                                        </Stack>
                                      )}

                                      <Box>
                                        {item.options_type === 'object_libraries' && (
                                          <Stack direction='column' justifyContent='flex-start'>
                                            <Typography variant='body2' sx={{ fontStyle: 'italic' }}>
                                              notes: item loaded from library only can be edited using library editor.
                                            </Typography>
                                            <Box>
                                              <Button onClick={() => window.open(`/portal/creator/library-editor`, '_blank')}>Library editor?</Button>
                                            </Box>
                                          </Stack>
                                        )}
                                      </Box>
                                    </Stack>
                                  ) : (
                                    <Typography variant='caption'>Please add new option</Typography>
                                  )}
                                </>
                                {/* <Divider />
                              <Typography>Has other value?</Typography>
                              <Stack direction='row' sx={{ alignItems: 'center' }}>
                                <Typography sx={{ flex: 1 }}>Tag: &nbsp;</Typography>
                                <TextField
                                  value={item.tag.other}
                                  sx={{ flex: 5 }}
                                  label='Other value key'
                                  placeholder='Other value key'
                                  id={item.tag}
                                  type='text'
                                  inputProps={inputProps}
                                  size='small'
                                  onChange={(e) => {
                                    if (e.currentTarget.value) {
                                      const isDuplicated = headers.filter((item) => item.tag === e.currentTarget.value.replace(/\s+/g, '').toLowerCase());
                                      if (isDuplicated.length > 0)
                                        return toast.error(
                                          `Tag ${e.currentTarget.value.replace(/\s+/g, '').toLowerCase()} is duplicated, please use another tag.`
                                        );
                                      updateHeaders(index, e.currentTarget.value.replace(/\s+/g, '').toLowerCase(), 'tag');
                                    } else {
                                      updateHeaders(index, e.currentTarget.value.replace(/\s+/g, '').toLowerCase(), 'tag');
                                    }
                                  }}
                                />
                              </Stack> */}
                              </Stack>
                            </>
                          )}
                        </Stack>
                      </Stack>
                    </Stack>
                  )}
                </Card>
              ))}
          </Stack>

          <Stack direction='row' spacing={4} justifyContent='center' alignItems='center'>
            <Stack direction='column' spacing={1}>
              <Stack direction='row' mt={2} justifyContent='center'>
                <IconButton color='primary' onClick={() => setQuestionDialogOpen(true)} aria-label='New Question' size='large'>
                  <Add />
                </IconButton>
              </Stack>
              <Stack direction='row' mb={3} justifyContent='center'>
                <Typography color='primary' sx={{ cursor: 'pointer', fontWeight: 700, color: colors.grey[900] }} onClick={() => setQuestionDialogOpen(true)}>
                  Add New Question
                </Typography>
              </Stack>
            </Stack>
            <Divider flexItem orientation='vertical'></Divider>
            <Stack direction='column' spacing={1}>
              <Stack direction='row' mt={2} justifyContent='center'>
                <IconButton color='primary' onClick={() => setSectionDialogOpen(true)} aria-label='New Section' size='large'>
                  <Add />
                </IconButton>
              </Stack>
              <Stack direction='row' mb={3} justifyContent='center'>
                <Typography color='primary' sx={{ cursor: 'pointer', fontWeight: 700, color: colors.grey[900] }} onClick={() => setSectionDialogOpen(true)}>
                  Add New Section
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>

        <Stack sx={{ position: 'fixed', bottom: 50, right: 50 }}>
          <FABAction loading={isLoading} onClick={updateTableProps} />
        </Stack>

        {/* Dialogs */}

        <FormDialog open={openFormDialog} setOpen={setFormDialogOpen} updateHeaders={updateHeaders} metadata={itemMeta} />
        <FormlistDialog
          open={openFormlistDialog}
          setOpen={setOpenFormlistDialog}
          updateHeaders={updateHeaders}
          metadata={itemMeta}
          objectLibraries={objectLibraries}
        />
        <QuestionDialog open={openQuestionDialog} setOpen={setQuestionDialogOpen} addQuestion={addQuestion} />
        <SectionDialog open={openSectionDialog} setOpen={setSectionDialogOpen} addSection={addSection} />
        <DialogConfirmation
          open={confirmationOpen}
          handleClose={() => setConfirmationOpen(false)}
          title='Deletion Confirmation'
          content='Are you sure want to delete this data?'
          closeButtonText='No'
          agreeButtonText='Yes'
          handleAgree={() => handleQuestionDelete(questionMeta, questionMeta.index, true)}
        />
        {/* <Typography>{JSON.stringify(headers)}</Typography> */}
        {/* {authGranted && (
        <>
          <Typography>{sheet.title}</Typography>
          <Typography>{JSON.stringify(headers)}</Typography>

          <Button onClick={() => createNewRow()}>Add new Row</Button>
        </>
      )} */}
      </Container>
    </Box>
  );
};

export default Creator;
